// extracted by mini-css-extract-plugin
export default {"analytic-cards":"analytic-cards_analytic-cards__Gx13n"};